module.exports = __webpack_public_path__ + "static/assets/fb58160116511d09a78bc81523670ea9.png";